// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2L2Nf","rootSmall":"AddTileButton_rootSmall__1PTex"};